/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import { connect } from 'react-redux';
import { hideModal, showModal } from '../../../actions/actions';
import { MODAL_TYPE_PARTICIPANT_ARCHIVE_EXPORT } from '../../../constants/modalTypes';
import ParticipantArchiveModal from './participant-archive.modal';
import * as consts from '../../../const';

export const mapStateToProps = (state, ownProps) => {
  return {
    study: state.subject.participantStudy
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    close: () => {
      dispatch(hideModal());
    },
    goNext: (study) => {
      dispatch(
        showModal(MODAL_TYPE_PARTICIPANT_ARCHIVE_EXPORT, {
          title: consts.PARTICIPANT_ARCHIVE_TITLE,
          subtitle: study.name,
          details: consts.SELECT_TO_EXPORT,
          shouldCloseOnOverlayClick: false,
          className: 'all-reports-modal tc-modal tc-modal-med'
        })
      );
    }
  };
};

const ParticipantArchiveModalContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantArchiveModal);
export default ParticipantArchiveModalContainer;
